import RegisterModal from './register-modal';
export default RegisterModal;